import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ApiClientService } from '../../services/api-client.service';

@Injectable()
export class SettingService extends ApiClientService {
  urlPath: string = `/settings`;

  constructor(api: ApiService) {
    super(api);
  }
}
